import React from 'react'
import { MainDiv } from '../../components/Profile/Profile.style';
import { VolunteerHeading } from '../../components/Volunteer/Volunteer.style';
import ThanaSetup from '../../components/setup/ThanaSetup/ThanaSetup';

const ThanaSetupPage=()=> {
    return (
        <MainDiv>
          <VolunteerHeading>Thana Setup</VolunteerHeading>
          <ThanaSetup/>
        </MainDiv>
      );
}
export default ThanaSetupPage;